import React, { useEffect, useRef, useState } from "react";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MenuIcon from "@mui/icons-material/Menu";
// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min'
import { Offcanvas, Collapse } from "bootstrap";
import {
  getHardwareCategoryApi,
  getHardwareListApi,
} from "./api/shop/hardware";
import {
  categoryFailure,
  categorySuccess,
  dataListFailure,
  dataListSucess,
} from "../Store/reducer/hardware";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const [menu1, setMenu1] = useState(false);
  const [sideMenu1, setSideMenu1] = useState([true, false, false, false]);
  const [menu2, setMenu2] = useState(false);
  const [, setMenu3] = useState(false);
  // const [menu3, setMenu3] = useState(false);
  const [menu4, setMenu4] = useState(false);
  const [isSccroll, setIsSccroll] = useState(false);
  const { pathname } = useLocation();
  const hardware = useSelector((state) => state.dataList.hardware);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getHardwareListApi()
      .then((res) => {
        dispatch(dataListSucess(res?.data));
      })
      .catch(() => {
        dispatch(dataListFailure());
      });
  }, []);

  useEffect(() => {
    getHardwareCategoryApi()
      .then((res) => {
        dispatch(categorySuccess(res?.data));
      })
      .catch(() => {
        dispatch(categoryFailure());
      });
  }, []);

  useEffect(() => {
    setMenu1(false);
    setMenu2(false);
    setMenu3(false);
    setMenu4(false);
    document.getElementById("closeOffCanvas").click();
    document.getElementById("closeOffCanvas1").click();

    // if (pathname != "/") {
    //   constmaxWidth = 567;
    //   if (window.innerWidth < maxWidth) {
    //     document.getElementById("close_collopsNav").click();
    //   }
    // }

    const offcanvasEl = document.getElementById("businesstype");
    const offcanvasE2 = document.getElementById("contactHelp");
    const offcanvasE3 = document.getElementById("resourceMenu");
    const offcanvasE4 = document.getElementById("prodcutFusion");
    const bsOffcanvas = Offcanvas.getInstance(offcanvasEl);
    const bsOffcanvas2 = Offcanvas.getInstance(offcanvasE2);
    const bsOffcanvas3 = Offcanvas.getInstance(offcanvasE3);
    const bsOffcanvas4 = Offcanvas.getInstance(offcanvasE4);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }

    if (bsOffcanvas3) {
      bsOffcanvas3.hide();
    }

    if (bsOffcanvas2) {
      bsOffcanvas2.hide();
    }

    if (bsOffcanvas4) {
      bsOffcanvas4.hide();
    }

    const navbarCollapseEl = document.getElementById("navbarText");
    if (navbarCollapseEl?.classList.contains("show")) {
      const collapseInstance = Collapse.getInstance(navbarCollapseEl);
      if (collapseInstance) {
        collapseInstance.hide();
      }
    }
  }, [pathname]);

  const profRef = useRef(null);
  const profRef2 = useRef(null);
  const profRef3 = useRef(null);

  const handleClickOutside = (event) => {
    if (profRef.current && !profRef.current.contains(event.target)) {
      setMenu1(false);
    }
    if (profRef2.current && !profRef2.current.contains(event.target)) {
      setMenu2(false);
    }
    if (profRef3.current && !profRef3.current.contains(event.target)) {
      setMenu3(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleScroll = () => {
    try {
      let number =
        window?.pageXOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        3;

      if (number >= 5) {
        if (window.innerWidth < 5) {
          document.getElementById("offcan")?.classList.add("mt-lg-0");
          document.getElementById("offcan1")?.classList.add("mt-lg-0");
          document.getElementById("offcan2")?.classList.add("mt-lg-0");
          document.getElementById("offcan3")?.classList.add("mt-lg-0");
          document.getElementById("sticky")?.classList.remove("head-stick");
          setIsSccroll(false);
          if (window.location.pathname == "/") {
            document.getElementById("sticky")?.classList.add("head-stick2");
          }
        } else {
          document.getElementById("offcan")?.classList.remove("mt-lg-0");
          document.getElementById("offcan1")?.classList.remove("mt-lg-0");
          document.getElementById("offcan2")?.classList.remove("mt-lg-0");
          document.getElementById("offcan3")?.classList.remove("mt-lg-0");
          document.getElementById("sticky")?.classList.add("head-stick");
          setIsSccroll(true);
          if (window.location.pathname == "/") {
            document.getElementById("sticky")?.classList.remove("head-stick2");
          }
        }
      } else {
        document.getElementById("offcan")?.classList.add("mt-lg-0");
        document.getElementById("offcan1")?.classList.add("mt-lg-0");
        document.getElementById("offcan2")?.classList.add("mt-lg-0");
        document.getElementById("offcan3")?.classList.add("mt-lg-0");
        document.getElementById("sticky")?.classList.remove("head-stick");
        setIsSccroll(false);
        if (window.location.pathname == "/") {
          document.getElementById("sticky")?.classList.add("head-stick2");
        }
      }
    } catch (error) {
      // console.log("err", error.message);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleToggle = () => {
    const collapseEl = document.getElementById("navbarText");

    if (collapseEl) {
      const bsCollapse = Collapse.getInstance(collapseEl);

      if (collapseEl?.classList.contains("show")) {
        if (bsCollapse) {
          bsCollapse.hide();
        } else {
          new Collapse(collapseEl, {
            toggle: false,
          }).hide();
        }
      } else {
        if (bsCollapse) {
          bsCollapse.show();
        } else {
          new Collapse(collapseEl, {
            toggle: false,
          }).show();
        }
      }
    }
  };

  const handleToggle2 = (mn) => {
    const collapseEl = document.getElementById(`men${mn}`);

    if (collapseEl) {
      const bsCollapse = Collapse.getInstance(collapseEl);

      if (collapseEl?.classList.contains("show")) {
        if (bsCollapse) {
          bsCollapse.hide();
        } else {
          new Collapse(collapseEl, {
            toggle: false,
          }).hide();
        }
      } else {
        if (bsCollapse) {
          bsCollapse.show();
        } else {
          new Collapse(collapseEl, {
            toggle: false,
          }).show();
        }
      }
    }
  };

  return (
    <header className="shadow-sm">
      <nav
        id={"sticky"}
        className={`${
          window.location.pathname == "/"
            ? "head-stick2 "
            : " bg-body-White shadow-sm"
        } navbar   navbar-expand-lg `}
      >
        <div
          className={`${
            window.location.pathname == "/" ? "container" : "container"
          }  px-lg-3 px-2 top_ps`}
        >
          <Link className="navbar-brand" to="/">
            <img
              src={
                !isSccroll && window.location.pathname == "/"
                  ? "/assets/img/nav/logoW.png"
                  : "/assets/img/nav/logo.png"
              }
              className="logo"
              loading="lazy"
              alt="logo"
            />
          </Link>

          <div className="d-lg-none d-flex  align-items-center gap-1">
            <Link to="/get-started" className="text-color">
              Start for free
            </Link>
            <button
              className="navbar-toggler border-0"
              type="button"
              aria-controls="navbarText"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={handleToggle}
            >
              <MenuIcon />
            </button>
          </div>
          <div className="collapse navbar-collapse hom-nab " id="navbarText">
            <ul className=" navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className={`${menu1 ? "active" : ""} nav-link`}
                  onClick={() => {
                    setMenu4(false);
                    setMenu1(!menu1);
                    setMenu2(false);
                    setMenu3(false);
                  }}
                  data-bs-toggle="offcanvas"
                  href="#prodcutFusion"
                  role="button"
                  aria-controls="prodcutFusion"
                  aria-current="page"
                >
                  Product
                  <KeyboardArrowRightIcon
                    className={`${menu1 ? "togg" : ""} d-lg-none`}
                  />
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`${menu2 ? "active" : ""} nav-link`}
                  onClick={() => {
                    setMenu4(false);
                    setMenu2(!menu2);
                    setMenu1(false);
                    setMenu3(false);
                  }}
                  data-bs-toggle="offcanvas"
                  href="#businesstype"
                  role="button"
                  aria-controls="businesstype"
                >
                  Business Types{" "}
                  <KeyboardArrowRightIcon
                    className={`${menu2 ? "togg" : ""} d-lg-none`}
                  />
                </a>
              </li>
              <li className="nav-item">
                <Link className={`nav-link`} to="/pricing">
                  Pricing
                </Link>
              </li>
              {/* <li className="nav-item">
                <a
                  className={`${menu3 ? "active" : ""} nav-link`}
                  onClick={() => {
                    setMenu4(false);
                    setMenu3(!menu3);
                    setMenu2(false);
                    setMenu1(false);
                  }}
                  data-bs-toggle="offcanvas"
                  href="#resourceMenu"
                  role="button"
                  aria-controls="resourceMenu"
                >
                  Resources{" "}
                  <KeyboardArrowRightIcon
                    className={`${menu3 ? "togg" : ''} d-lg-none`}
                  />
                </a>
              </li> */}

              <li className="nav-item">
                <a
                  className={`${menu4 ? "active" : ""} nav-link `}
                  onClick={() => {
                    setMenu4(!menu4);
                    setMenu3(false);
                    setMenu2(false);
                    setMenu1(false);
                  }}
                  data-bs-toggle="offcanvas"
                  href="#contactHelp"
                  role="button"
                  aria-controls="contactHelp"
                >
                  Help
                </a>
              </li>

              {hardware?.length > 0 && hardware?.find((e) => e?.status == 1) ? (
                <li className="nav-item">
                  <Link className={`nav-link`} to="/shop-catalogue">
                    Shop
                  </Link>
                </li>
              ) : (
                ""
              )}

              <button
                onClick={() => navigate("/get-started")}
                className="d-lg-none btn btn-dark w-100 mt-3 p-2"
              >
                Login
              </button>
            </ul>

            <span className="navbar-text ">
              <div className="d-lg-flex d-none align-items-center gap-3 flex-wrap">
                <Link className="nav-link " to="/get-started">
                  <PersonOutlinedIcon /> Login
                </Link>
                <button
                  type="button"
                  onClick={() => navigate("/get-started")}
                  className="btn btn-dark"
                >
                  Get Started
                </button>
              </div>
            </span>
          </div>
        </div>
      </nav>

      {/* product */}
      <div
        className="offcanvas offcanvas-start"
        // tabindex="1"
        data-bs-scroll="true"
        id="prodcutFusion"
        aria-labelledby="prodcutFusionLabel"
      >
        <div className="offcanvas-header">
          <Link className="navbar-brand" to="/">
            <img
              loading="lazy"
              src="/assets/img/nav/logo.png"
              className="logo"
              alt="logo"
            />
          </Link>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            id="closeOffCanvas"
            aria-label="Close"
            onClick={() => {
              setMenu1(false);
              setMenu2(false);
              setMenu3(false);
              setMenu4(false);
            }}
          ></button>
        </div>
        <div id="offcan" className="offcanvas-body menu_jh mt-lg-0">
          <div className="row h-100">
            <div className="col-lg-6 d-lg-block d-none border-end">
              <div className="text-start d-flex flex-column gap-3 sideMenu">
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/foodBaveage.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[0] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([true, false, false, false]);
                    }}
                  >
                    FOOD & BEVERAGE
                  </h5>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/retail.webp"
                    alt="retail"
                  />
                  <h5
                    className={sideMenu1[1] ? "text-color" : ""}
                    data-bs-toggle="collapse"
                    href="#collapseExample"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                    onMouseOver={() => {
                      setSideMenu1([false, true, false, false]);
                    }}
                  >
                    RETAIL
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/beauty.webp"
                    alt=""
                  />
                  <div className="l">
                    <h5
                      className={sideMenu1[2] ? "text-color" : ""}
                      onMouseOver={() => {
                        setSideMenu1([false, false, true, false]);
                      }}
                    >
                      BEAUTY & SERVICES
                    </h5>
                    {/* <small className="text-color">coming soon</small> */}
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/manage.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[3] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, false, false, true]);
                    }}
                  >
                    MANAGE FINANCES
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-lg-block d-flex flex-column gap-3">
              <a
                className={`${
                  sideMenu1[0] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, !sideMenu1[1], false, false]);
                  handleToggle2(2);
                }}
                // data-bs-toggle="collapse"
                // href="#men2"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men2"
              >
                FOOD & BEVERAGE
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[0] ? "togg" : ""} d-lg-none`}
                />
              </a>
              <div id="men2" className="collapse colabody">
                <ul id="" className={sideMenu1[0] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/restaurant-overview">Overview</Link>
                  </li>
                  <li>
                    <Link to="/restaurant-pos">Point of Sale</Link>
                  </li>
                  <li>
                    <Link to={"/best-online-ordering"}>Online Store</Link>
                  </li>
                  <li>
                    <Link to={"/self-serve-kiosks"}>Kiosk</Link>
                  </li>
                  <li>
                    <Link to={"/inventory-management"}>Inventory</Link>
                  </li>
                  <li>
                    <Link to="/payments">Payments</Link>
                  </li>
                  <li>
                    <Link to="/kitchen-display">Kitchen Display System</Link>
                  </li>
                  <li>
                    <Link to={"/cash-advance"}>Capital</Link>
                    {/* <br /> */}
                    {/* <small className="text-color">coming soon</small> */}
                  </li>
                  {/* <li>
                    <Link to="/catering-and-events">Catering Events</Link>
                    <br />
                  </li> */}
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[1] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([true, false, false, false]);
                  handleToggle2(1);
                }}
                // data-bs-toggle="collapse"
                // href="#men1"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men1"
              >
                RETAIL
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[1] ? "togg" : ""} `}
                />
              </a>
              <div id="men1" className="collapse colabody">
                <ul className={` ${sideMenu1[1] ? "d-block" : "d-lg-none"}`}>
                  <li>
                    <Link to="/retail-pos">Overview</Link>
                  </li>
                  <li>
                    <Link to="/pos-system">Point of Sale</Link>
                  </li>
                  <li>
                    <Link to="/payments">Payment</Link>
                  </li>
                  <li>
                    <Link to="/online-ordering">Online Store</Link>
                  </li>
                  <li>
                    <Link to="/inventory-management">Inventory Management</Link>
                  </li>
                  <li>
                    <Link href="/">Scanner</Link>
                    <br />
                    <small className="text-color">coming soon</small>
                  </li>
                  <li>
                    <Link to={"/cash-advance"}>Capital</Link>
                    <br />
                    {/* <small className="text-color">coming soon</small> */}
                  </li>
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[2] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, !sideMenu1[2], false]);
                  handleToggle2(3);
                }}
                // data-bs-toggle="collapse"
                // href="#men3"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men3"
              >
                BEAUTY & SERVICES
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[2] ? "togg" : ""} `}
                />
              </a>
              {/* <small className="text-color">coming soon</small> */}

              <div id="men3" className="collapse colabody">
                <ul id="" className={sideMenu1[2] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/beauty">Overview</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Beauty salon</Link> */}
                    <Link to="/salon-pos">Beauty salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Nail salon</Link> */}
                    <Link to="/nail-salon-pos">Nail salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Hair salon</Link> */}
                    <Link to="/hair-salon-pos">Hair salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Day spa</Link> */}
                    <Link to="/day-spa-pos">Day spa</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Barbershop</Link> */}
                    <Link to="/barbershop-pos">Barbershop</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Tattoo & piercing</Link> */}
                    <Link to="/tattoo-piercing-pos">Tattoo & piercing</Link>
                  </li>
                  <li>
                    <Link to="/med-spa-pos">Med spa</Link>
                  </li>
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[3] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, false, !sideMenu1[3]]);
                  handleToggle2(4);
                }}
                // data-bs-toggle="collapse"
                // href="#men4"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men4"
              >
                MANAGE FINANCES
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[3] ? "togg" : ""} d-lg-none`}
                />
              </a>
              <div id="men4" className="collapse colabody">
                <ul id="" className={sideMenu1[3] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/business-account">Business Account</Link>
                  </li>
                  <li>
                    <Link to="/visacard">VisaCard</Link>
                  </li>
                  <li>
                    <Link to="/cash-advance">Cash Advance</Link>
                    {/* <br /> */}
                    {/* <small className="text-color">coming soon</small> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* business Type */}
      <div
        className="offcanvas offcanvas-start"
        // tabindex="2"
        data-bs-scroll="true"
        id="businesstype"
        aria-labelledby="businesstypeLabel"
      >
        <div className="offcanvas-header">
          <Link className="navbar-brand" to="/">
            <img
              loading="lazy"
              src="/assets/img/nav/logo.png"
              className="logo"
              alt="logo"
            />
          </Link>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            id="closeOffCanvas1"
            onClick={() => {
              setMenu1(false);
              setMenu2(false);
              setMenu3(false);
              setMenu4(false);
            }}
          ></button>
        </div>
        <div id="offcan1" className="offcanvas-body menu_jh mt-lg-0">
          <div className="row h-100">
            <div className="col-lg-6 d-lg-block d-none border-end">
              <div className="text-start d-flex flex-column gap-3 sideMenu">
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/foodBaveage.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[0] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([true, false, false, false]);
                    }}
                  >
                    FOOD & BEVERAGE
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/retail.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[1] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, true, false, false]);
                    }}
                  >
                    RETAIL
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/beauty.webp"
                    alt=""
                  />
                  <div className="l">
                    <h5
                      className={sideMenu1[2] ? "text-color" : ""}
                      onMouseOver={() => {
                        setSideMenu1([false, false, true, false]);
                      }}
                    >
                      BEAUTY & SERVICES
                    </h5>
                    {/* <small className="text-color">coming soon</small> */}
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/manage.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[3] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, false, false, true]);
                    }}
                  >
                    MANAGE FINANCES
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-lg-block d-flex flex-column gap-3">
              <a
                className={`${
                  sideMenu1[0] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([true, false, false, false]);
                  handleToggle2(5);
                }}
                // data-bs-toggle="collapse"
                // href="#men1"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men1"
              >
                FOOD & BEVERAGE
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[0] ? "togg" : ""} `}
                />
              </a>
              <div id="men5" className="collapse colabody">
                <ul className={sideMenu1[0] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/restaurant-overview">Overview</Link>
                  </li>
                  <li>
                    <Link to="/industries/food-drink">Food & drink</Link>
                  </li>
                  <li>
                    <Link to="/industries/bar-club">Bar & club</Link>
                  </li>
                  <li>
                    <Link to="/industries/restaurant">
                      Coffee shop & restaurant
                    </Link>
                  </li>
                  <li>
                    <Link to="/industries/food-truck">Food truck</Link>
                  </li>
                  <li>
                    <Link to="/industries/grocery">Grocery shop</Link>
                  </li>
                  <li>
                    <Link to="/industries/market-stall">Market stall</Link>
                  </li>
                  <li>
                    <Link to="/industries/quick-service">
                      Quick service restaurant
                    </Link>
                  </li>
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[1] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, !sideMenu1[1], false, false]);
                  handleToggle2(6);
                }}
                // data-bs-toggle="collapse"
                // href="#men2"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men2"
              >
                RETAIL
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[1] ? "togg" : ""} `}
                />
              </a>

              <div id="men6" className="collapse colabody">
                <ul id="" className={sideMenu1[1] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/retail-pos">Overview</Link>
                  </li>
                  <li>
                    <Link to={"/industries/clothing"}>Clothing</Link>
                  </li>
                  <li>
                    <Link to={"/industries/home-gift"}>Home & Gift</Link>
                  </li>
                  <li>
                    <Link to={"/industries/bar-club"}>wine & liquor</Link>
                  </li>
                  <li>
                    <Link to={"/industries/grocery"}>Grocery</Link>
                  </li>
                  <li>
                    <Link to={"/industries/garden"}>Garden</Link>
                  </li>
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[2] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, !sideMenu1[2], false]);
                  handleToggle2(7);
                }}
                // data-bs-toggle="collapse"
                // href="#men3"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men3"
              >
                BEAUTY & SERVICES
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[2] ? "togg" : ""} `}
                />
              </a>
              {/* <small className="text-color">coming soon</small> */}

              <div id="men7" className="collapse colabody">
                <ul id="" className={sideMenu1[2] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/beauty">Overview</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Beauty salon</Link> */}
                    <Link to="/salon-pos">Beauty salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Nail salon</Link> */}
                    <Link to="/nail-salon-pos">Nail salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Hair salon</Link> */}
                    <Link to="/hair-salon-pos">Hair salon</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Day spa</Link> */}
                    <Link to="/day-spa-pos">Day spa</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Barbershop</Link> */}
                    <Link to="/barbershop-pos">Barbershop</Link>
                  </li>
                  <li>
                    {/* <Link to="/beauty">Tattoo & piercing</Link> */}
                    <Link to="/tattoo-piercing-pos">Tattoo & piercing</Link>
                  </li>
                  <li>
                    <Link to="/med-spa-pos">Med spa</Link>
                  </li>
                </ul>
              </div>

              <a
                className={`${
                  sideMenu1[3] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, false, !sideMenu1[3]]);
                  handleToggle2(8);
                }}
                // data-bs-toggle="collapse"
                // href="#men4"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men4"
              >
                MANAGE FINANCES
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[3] ? "togg" : ""} d-lg-none`}
                />
              </a>
              <div id="men8" className="collapse colabody">
                <ul id="" className={sideMenu1[3] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/business-account">Business Account</Link>
                  </li>
                  <li>
                    <Link to="/visacard">VisaCard</Link>
                  </li>
                  <li>
                    <Link to="/cash-advance">Cash Advance</Link>
                    {/* <br /> */}
                    {/* <small className="text-color">coming soon</small> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resource */}
      <div
        className="offcanvas offcanvas-start"
        // tabindex="3"
        data-bs-scroll="true"
        id="resourceMenu"
        aria-labelledby="resourceMenuLabel"
      >
        <div className="offcanvas-header">
          <Link className="navbar-brand" to="/">
            <img
              loading="lazy"
              src="/assets/img/nav/logo.png"
              className="logo"
              alt="logo"
            />
          </Link>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            id="closeOffCanvas"
            aria-label="Close"
            onClick={() => {
              setMenu1(false);
              setMenu2(false);
              setMenu3(false);
              setMenu4(false);
            }}
          ></button>
        </div>
        <div id="offcan2" className="offcanvas-body menu_jh mt-lg-0">
          <div className="row h-100">
            <div className="col-lg-6 d-lg-block d-none border-end">
              <div className="text-start d-flex flex-column gap-3 sideMenu">
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" src="/assets/img/nav1.jpg" alt="" />
                  <h5
                    className={sideMenu1[0] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([true, false, false, false]);
                    }}
                  >
                    HUBS
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" src="/assets/img/nav2.jpg" alt="" />
                  <h5
                    className={sideMenu1[1] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, true, false, false]);
                    }}
                  >
                    GUIDES
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" src="/assets/img/nav3.png" alt="" />
                  <h5
                    className={sideMenu1[2] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, false, true, false]);
                    }}
                  >
                    ABOUT US
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" src="/assets/img/nav4.png" alt="" />
                  <h5
                    className={sideMenu1[3] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, false, false, true]);
                    }}
                  >
                    SELL MORE
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-lg-block d-flex flex-column gap-3">
              <a
                className={`${
                  sideMenu1[0] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([true, false, false, false]);
                  handleToggle2(1);
                }}
                // data-bs-toggle="collapse"
                // href="#men1"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men1"
              >
                HUBS
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[0] ? "togg" : ""} `}
                />
              </a>
              <div id="men1" className="collapse colabody">
                <ul id="" className={sideMenu1[0] ? "d-block" : "d-lg-none"}>
                  <li>
                    <a href="/">Business ideas</a>
                  </li>
                  <li>
                    <a href="/">Starting a Business</a>
                  </li>
                  <li>
                    <a href="/">Running a Business</a>
                  </li>
                </ul>
              </div>
              <a
                className={`${
                  sideMenu1[1] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, !sideMenu1[1], false, false]);
                  handleToggle2(2);
                }}
                // data-bs-toggle="collapse"
                // href="#men2"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men2"
              >
                GUIDES
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[1] ? "togg" : ""} `}
                />
              </a>
              <div id="men2" className="collapse colabody">
                <ul id="" className={sideMenu1[1] ? "d-block" : "d-lg-none"}>
                  <li>
                    <a href="/">Business Guide</a>
                  </li>
                  <li>
                    <a href="/">Invoice Hub</a>
                  </li>
                  <li>
                    <a href="/">Dictionary</a>
                  </li>
                </ul>
              </div>
              <a
                className={`${
                  sideMenu1[2] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, !sideMenu1[2], false]);
                  handleToggle2(3);
                }}
                // data-bs-toggle="collapse"
                // href="#men3"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men3"
              >
                ABOUT US
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[2] ? "togg" : ""} `}
                />
              </a>
              <div id="men3" className="collapse colabody">
                <ul id="" className={sideMenu1[2] ? "d-block" : "d-lg-none"}>
                  <li>
                    <a href="/">Mission</a>
                  </li>
                  <li>
                    <a href="/">Partners</a>
                  </li>
                  <li>
                    <a href="/">Careers</a>
                  </li>
                </ul>
              </div>
              <a
                className={`${
                  sideMenu1[3] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, false, false, !sideMenu1[3]]);
                  handleToggle2(4);
                }}
                // data-bs-toggle="collapse"
                // href="#men4"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men4"
              >
                SELL MORE
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[3] ? "togg" : ""} `}
                />
              </a>
              <div id="men4" className="collapse colabody">
                <ul id="" className={sideMenu1[3] ? "d-block" : "d-lg-none"}>
                  <li>
                    <a href="/">Gift Cards</a>
                  </li>
                  <li>
                    <a href="/">Loyalty</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Help */}
      <div
        className="offcanvas offcanvas-start"
        // tabindex="-1"
        data-bs-scroll="true"
        id="contactHelp"
        aria-labelledby="contactHelpLabel"
      >
        <div className="offcanvas-header">
          <Link className="navbar-brand" to="/">
            <img
              loading="lazy"
              src="/assets/img/nav/logo.png"
              className="logo"
              alt="logo"
            />
          </Link>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            id="closeOffCanvas"
            aria-label="Close"
            onClick={() => {
              setMenu1(false);
              setMenu2(false);
              setMenu3(false);
            }}
          ></button>
        </div>
        <div id="offcan3" className="offcanvas-body menu_jh mt-lg-0">
          <div className="row h-100">
            <div className="col-lg-6 d-lg-block d-none border-end">
              <div className="text-start d-flex flex-column gap-3 sideMenu">
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" src="/assets/img/nav/sale.webp" alt="" />
                  <h5
                    className={sideMenu1[0] ? "text-color" : ""}
                    onClick={() => {
                      navigate("/contact");
                    }}
                    onMouseOver={() => {
                      setSideMenu1([true, false, false, false]);
                    }}
                  >
                    Contact Sales
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/support.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[1] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, true, false, false]);
                    }}
                    onClick={() => {
                      navigate("/help-and-support");
                    }}
                  >
                    Contact Support
                  </h5>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    loading="lazy"
                    src="/assets/img/nav/Partnership.webp"
                    alt=""
                  />
                  <h5
                    className={sideMenu1[2] ? "text-color" : ""}
                    onMouseOver={() => {
                      setSideMenu1([false, false, true, false]);
                    }}
                    onClick={() => {
                      navigate("/partners");
                    }}
                  >
                    Partnership
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-lg-block d-flex flex-column gap-3">
              <a
                className={`${
                  sideMenu1[0] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([true, false, false, false]);
                  handleToggle2(1);
                }}
                // data-bs-toggle="collapse"
                // href="#men1"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men1"
              >
                Contact Sales
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[0] ? "togg" : ""} `}
                />
              </a>
              <div id="men1" className="collapse colabody">
                <ul id="" className={sideMenu1[0] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/contact" className="text-black">
                      Contact sales
                    </Link>
                    <br />
                    <small className="text-muted">Contact our sales team</small>
                  </li>
                  <li>
                    <Link to="/contact" className="text-black">
                      Phone
                    </Link>
                    <br />
                    <small className="text-muted">
                      <a
                        href="tel:0447782556546"
                        className="text-decoration-none text-dark text-wrap"
                      >
                        044 7782 556 546
                      </a>
                    </small>
                  </li>
                </ul>
              </div>
              <a
                className={`${
                  sideMenu1[1] ? "active" : ""
                } moblile_nav d-lg-none`}
                onClick={() => {
                  setSideMenu1([false, !sideMenu1[1], false, false]);
                  handleToggle2(2);
                }}
                // data-bs-toggle="collapse"
                // href="#men2"
                // role="button"
                // aria-expanded="false"
                // aria-controls="men2"
              >
                Contact Support
                <KeyboardArrowRightIcon
                  className={`${sideMenu1[1] ? "togg" : ""} `}
                />
              </a>
              <div id="men2" className="collapse colabody">
                <ul id="" className={sideMenu1[1] ? "d-block" : "d-lg-none"}>
                  <li>
                    <Link to="/help-and-support" className="text-black">
                      Live chat
                    </Link>
                    <br />
                    <small className="text-muted">
                      Chat with our support team
                    </small>
                  </li>
                  <li>
                    <Link to="/help-and-support" className="text-black">
                      Email
                    </Link>
                    <br />
                    <small className="text-muted">
                      sales@fusionmybusiness.com
                    </small>
                  </li>
                  <li>
                    <Link to="/help-and-support" className="text-black">
                      Whatsapp
                    </Link>
                    <br />
                    <small className="text-muted">
                      Chat with our support team
                    </small>
                  </li>
                </ul>
              </div>
              <Link className={`moblile_nav d-lg-none`} to="/partners">
                Partnership
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default React.memo(Header);
